import { BaseMapper } from '@ps/utils';

import { OperatorSettings } from '../../models/operator-settings.model';
import { OperatorSettingsDto } from '../dtos/operator-settings.dto';

export class OperatorSettingsMapper extends BaseMapper<
  OperatorSettingsDto,
  OperatorSettings
> {
  public fromDto(dto: OperatorSettingsDto): OperatorSettings {
    return {
      id: dto['id'] as number,
      ...dto,
    };
  }
}
